import { AppBar, Box, Tab, Tabs } from "@mui/material";
import feedIcon from "../../icons/feed.svg";
import eventsIcon from "../../icons/events.svg";
import LettersIcon from "../../icons/letters.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import { UserTab } from "../types";
import HostageFeed from "./HostageFeed";
import HostageActivities from "./HostageActivities";
import HostageLetters from "./HostageLetters";

export const HostageTabs = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = React.useState("Letters");

  const handleChange = (event: React.SyntheticEvent, newTab: UserTab) => {
    setSelectedTab(newTab);
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          top: 115,
          zIndex: 1100,
          boxShadow: "none",
        }}
      >
        <Tabs
          className="userTabs"
          value={selectedTab}
          onChange={handleChange}
          sx={{
            ".MuiTabs-flexContainer": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            ".MuiTabs-indicator": {
              height: "4px",
              backgroundColor: "#FF395D", // Change indicator to red
            },
            ".Mui-selected": {
              color: "black !important", // Selected tab text color
              borderBottom: "4px solid #FF395D", // Red bottom border for selected tab
            },
          }}
        >
          <Tab
            label={t("userHome.tabs.feed")}
            icon={<img src={feedIcon} alt="Feed" />}
            value="Feed"
          />
          <Tab
            label={t("userHome.tabs.events")}
            icon={<img src={eventsIcon} alt="Events" />}
            value="Activities"
          />
          <Tab
            label={t("userHome.tabs.letters")}
            icon={<img src={LettersIcon} alt="Letters" />}
            value="Letters"
          />
        </Tabs>
      </AppBar>
      <Box sx={{ backgroundColor: "#f6f6f6" }}>
        {selectedTab === "Feed" && <HostageFeed />}
        {selectedTab === "Activities" && <HostageActivities />}
        {selectedTab === "Letters" && <HostageLetters />}
      </Box>
    </>
  );
};
